<!-- Goal Actions -->
<div class="flex flex-{{ itemsDirection || 'col' }} gap-2">
  <!-- Transfer button -->
  @if (transferButtonOptions && transferButtonOptions.visible) {
    <button
      class="flex-row w-full gap-2 bg-white"
      mat-stroked-button
      [ngClass]="transferButtonOptions.extraClasses"
      [disabled]="transferButtonOptions.disabled || false"
    (click)="
      transferButtonOptions.action ? transferButtonOptions.action() : defaultOnTranferOrRescue()
    "
      [matTooltipPosition]="transferButtonOptions.tooltipPosition || 'below'"
      [matTooltip]="transferButtonOptions.tooltipText || ''"
      #transferTooltipProfile="matTooltip"
      (click)="transferTooltipProfile.toggle()"
      >
      {{ transferButtonOptions.text || 'Mover / Retirar' }}
      <mat-icon
        class="hidden md:flex"
        [svgIcon]="transferButtonOptions.icon || 'mat_outline:compare_arrows'"
      ></mat-icon>
    </button>
  }
  <!-- / Transfer button -->

  <!-- Deposit button -->
  @if (depositButtonOptions && depositButtonOptions.visible) {
    <button
      mat-flat-button
      class="flex-row w-full gap-2 text-white"
      color="primary"
      [ngClass]="depositButtonOptions.extraClasses"
      [disabled]="depositButtonOptions.disabled || false"
      (click)="depositButtonOptions.action ? depositButtonOptions.action() : defaultOnInvest()"
      [matTooltipPosition]="depositButtonOptions.tooltipPosition || 'below'"
      [matTooltip]="depositButtonOptions.tooltipText || ''"
      #depositTooltipProfile="matTooltip"
      (click)="depositTooltipProfile.toggle()"
      [attr.data-cy]="'cg-deposit-action-btn'"
      >
      {{ depositButtonOptions.text || 'Invertir más' }}
      <mat-icon
        class="hidden md:flex"
        [svgIcon]="depositButtonOptions.icon || 'mat_outline:add'"
      ></mat-icon>
    </button>
  }
  <!-- / Deposit button -->
</div>
<!-- / Goal Actions -->
